function getDateFromTripAndFlight(data: any) {
  if (data.type === "flight") {
    return data?.flight?.date ?? "";
  }
  return data?.date ?? "";
}

function mapRecord(ele: any, dateIndex: number, innerIndex: number) {
  const formatTime = (timeStr: string) => {
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours, 10);
    const minute = parseInt(minutes, 10);
    const isPM = hour >= 12;
    const formattedHour = hour % 12 || 12;
    const formattedMinutes = minute.toString().padStart(2, "0");
    const period = isPM ? "pm" : "am";
    return `${formattedHour}:${formattedMinutes} ${period}`;
  };

  return {
    ...ele,
    key: `${dateIndex}-${innerIndex} path_data`,
    pathway: ele?.name?.name,
    flight: ele?.name?.name,
    date: ele?.flight?.date || ele?.date,
    flightNum: ele?.flight?.flight_number,
    names: ele?.flight?.member?.name,
    fileNum: ele?.arrival?.file_number,
    agentFileNum: ele?.arrival?.agent_file_number,
    from: ele?.flight?.departure?.name,
    to: ele?.flight?.destination?.name,
    departureTime: ele?.flight?.departure_time,
    arrivalTime: ele?.flight?.arrival_time,
    adultNum: ele?.adult,
    childNum: ele?.child,
    pickUp: ele?.pick_up?.hotel_cruise?.name,
    dropTo: ele?.drop_off,
    ticketPrice: ele?.price,
    guideInVisits: ele?.guide?.username,
    guideFees: `${ele?.guide?.fee} ${ele?.guide?.fee_currency}`,
    leaderName: ele?.leader?.username,
    leaderFees: `${ele?.leader?.fee} ${ele?.leader?.fee_currency}`,
    driverName: ele?.transportation?.driver_name,
    vehicle: ele?.transportation?.plate_number,
    vehicleFees: `${ele?.transportation?.vehicle_fees} ${ele?.transportation?.vehicle_fees_currency}`,
    driverFees: `${ele?.transportation?.vehicle_fees} ${ele?.transportation?.vehicle_fees_currency}`,
    visaFees: `${ele?.visa_price} ${ele?.visa_purchase_currency?.name}`,
    note: ele?.note,
    city: ele?.city?.name,
    time: ele?.time ? formatTime(ele?.time) : "",
  };
}

export default function preparePathway(data: any[]) {
  // O(N) single-pass grouping by date using a Map (preserves insertion order)
  const grouped = new Map<string, any[]>();

  data.forEach((item) => {
    const dt = getDateFromTripAndFlight(item);
    if (!grouped.has(dt)) {
      grouped.set(dt, []);
    }
    grouped.get(dt)!.push(item);
  });

  let dateIndex = 0;
  const result: any[] = [];

  grouped.forEach((items, dt) => {
    result.push({
      id: `${dateIndex}-ee`,
      date: dt,
      mergedPathwayData: [],
      pathwayData: items.map((ele, innerIndex) =>
        mapRecord(ele, dateIndex, innerIndex)
      ),
    });
    dateIndex += 1;
  });

  return result;
}

export const mergeRows = (rowsToBeMerged: any, weekDays: any) => {
  const arrForMerge: any[] = [];

  rowsToBeMerged.forEach((row: any) => {
    const rowDate = row.date;
    const rowIds = [...row.ids];
    if (rowIds.length > 1) {
      const copyArr = [...weekDays];
      const indexOfWeekDay = copyArr.findIndex(
        (weekDay) => weekDay.date === rowDate
      );
      const pathwayDataToBeMerged = copyArr[
        indexOfWeekDay
      ]?.pathwayData?.filter((pth: any) => {
        return rowIds.includes(pth?.id);
      });

      const pathwayDataNotToBeMerged = copyArr[
        indexOfWeekDay
      ].pathwayData.filter((pth: any) => {
        return !rowIds.includes(pth?.id);
      });

      copyArr[indexOfWeekDay] = {
        ...copyArr[indexOfWeekDay],
        pathwayData: [...pathwayDataNotToBeMerged],
        mergedPathwayData: [
          ...copyArr[indexOfWeekDay].mergedPathwayData,
          [...pathwayDataToBeMerged],
        ],
      };

      arrForMerge.push(copyArr[indexOfWeekDay]);
    }
  });
};
